export function SingletonService(ctr) {
    let instance;
    return class {
        constructor(...args) {
            if (instance) {
                console.debug('You cannot instantiate a singleton twice!');
                return instance;
            }
            instance = new ctr(...args);
            return instance;
        }
    };
}
export function loadScript(url, async = true, defer = true, type) {
    return new Promise((resolve) => {
        const scriptElement = document.createElement('script');
        scriptElement.src = url;
        scriptElement.type = type || 'text/javascript';
        scriptElement.async = async;
        scriptElement.defer = defer;
        document.body.appendChild(scriptElement);
        scriptElement.addEventListener('load', () => resolve({ status: true }));
    });
}
export function loadStyle(url) {
    return new Promise((resolve) => {
        const head = document.getElementsByTagName('HEAD')[0];
        // Create new link Element
        const linkElement = document.createElement('link');
        // set the attributes for link element
        linkElement.rel = 'stylesheet';
        linkElement.type = 'text/css';
        linkElement.href = url;
        // Append link element to HTML head
        head.appendChild(linkElement);
        linkElement.addEventListener('load', () => resolve({ status: true }));
    });
}
//# sourceMappingURL=common.js.map